import React from "react"
import { useTranslation } from "react-i18next"
import Modal from "react-modal"

import "@knowit-alma/common/src/lang/i18n"

import styles from "./ModalWindow.module.scss"

Modal.setAppElement(`body`)

const ModalWindow = ({
  children,
  open,
  setOpen,
  label,
  modalStyle,
  margins = true,
  type = "regular",
}) => {
  const { t } = useTranslation()
  const camelCase = require("camelcase")
  return (
    <Modal
      className={`${styles.modal} ${margins ? styles.margins : styles.full}`}
      isOpen={open}
      //onAfterOpen={afterOpenModal}
      onRequestClose={() => setOpen(false)}
      contentLabel={label}
      closeTimeoutMS={300}
      overlayClassName={type ? styles[camelCase("" + type)] : false}
    >
      <div style={modalStyle}>
        {children}
        <button className={styles.close} onClick={() => setOpen(false)}>
          <span>{t("Close")}</span>
        </button>
      </div>
    </Modal>
  )
}

export default ModalWindow
